import React from 'react';
import { LocationMarkerIcon } from '../icons';
import './VenueCard.css';

export interface VenueCardProps {
    /** Venue display name */
    venueName: string;
    /** Location subtitle (e.g., "Tulsa, OK.") */
    location: string;
    /** Click handler */
    onClick?: () => void;
    /** Additional CSS class */
    className?: string;
}

export const VenueCard: React.FC<VenueCardProps> = ({
    venueName,
    location,
    onClick,
    className = '',
}) => {
    return (
        <div className={`venue-card ${className}`} onClick={onClick} role={onClick ? 'button' : undefined}>
            <div className="venue-card__icon">
                <LocationMarkerIcon size="l" tone="lightGrey" />
            </div>
            <div className="venue-card__info">
                <span className="venue-card__location">{location}</span>
                <span className="venue-card__name">{venueName}</span>
            </div>
        </div>
    );
};
